<template>
  <div class="t-app__container">
    <heading :overTitle="$t('stats-admin-dashboard-overTitle')" :title="$t('stats-admin-dashboard-title')" :text="$t('stats-admin-dashboard-text')" />
    <div class="h-section h-section--small-top">
      <admin-dashboard-tabs />
      <dashboard-section :title="$t('dashboard-admin-stats-title')">
        <button class="report-button a-btn-primary-outline a-btn-primary-outline--small" @click="showUsersReport">{{ $t('stats-users-title-button') }}</button><br />
        <button class="report-button a-btn-primary-outline a-btn-primary-outline--small" @click="showBusinessReport">{{ $t('stats-business-title-button') }}</button><br />
        <button class="report-button a-btn-primary-outline a-btn-primary-outline--small" @click="showRegisteredBusinessesReport">{{ $t('stats-registered-businesses-title-button') }}</button><br />
        <button class="report-button a-btn-primary-outline a-btn-primary-outline--small" @click="showEntrepreneursReport">{{ $t('stats-entrepreneurs-title-button') }}</button><br />
        <button class="report-button a-btn-primary-outline a-btn-primary-outline--small" @click="showGatheringsReport">{{ $t('stats-gatherings-title-button') }}</button><br />
        <report-popup title="" v-model="reportShow" :json="reportJson" @close="hideReport" />
      </dashboard-section>
    </div>
  </div>
</template>

<script>
import Heading from '@/components/heading'
import AdminDashboardTabs from '@/components/dashboard/admin-dashboard-tabs'
import DashboardSection from '@/components/dashboard/dashboard-section'
import ReportPopup from '@/components/popup/report-popup'

import LoaderService from '@/services/loader'
import StatsService from '@/services/stats'
import BusinessService from '@/services/business'

import { REGION_LABELS } from '@/helpers/region-labels'
import { HeardAboutMixin } from '@/mixins/form/heard-about'

export default {
  components: {
    Heading,
    AdminDashboardTabs,
    DashboardSection,
    ReportPopup
  },
  data() {
    return {
      userStats: {},
      gatheringStats: {},
      entrepreneurStats: {},
      businessReportJson: '',
      registeredBusinessReportJson: '',
      reportJson: '',
      reportShow: false
    }
  },
  methods: {
    showUsersReport: function() {
      this.reportShow = true
      this.reportJson = JSON.stringify(this.userStats.Users)
    },
    showEntrepreneursReport: function() {
      this.reportShow = true
      this.reportJson = JSON.stringify(this.entrepreneurStats.Entrepreneurs)
    },
    showGatheringsReport: function() {
      this.reportShow = true
      this.reportJson = JSON.stringify(this.gatheringStats.Gatherings)
    },
    showBusinessReport: async function() {
      if (this.businessReportJson === '') {
        this.businessReportJson = await BusinessService.getBusinessesJSON()
      }
      this.reportShow = true
      this.reportJson = this.businessReportJson
    },
    showRegisteredBusinessesReport: async function() {
      if (this.registeredBusinessReportJson === '') {
        this.registeredBusinessReportJson = await BusinessService.getBusinessesJSON(true)
      }
      this.reportShow = true
      this.reportJson = this.registeredBusinessReportJson
    },
    hideReport: function() {
      this.reportShow = false
      this.reportJson = {}
    }
  },
  mixins: [HeardAboutMixin],
  async beforeRouteEnter(to, from, next) {
    LoaderService.showLoader()

    let userStats = await StatsService.getUsersStats()
    let gatheringStats = await StatsService.getGatheringsStats()
    let entrepreneurStats = await StatsService.getEntrepreneursStats()

    next(vm => {
      entrepreneurStats.Entrepreneurs.forEach(x => {
        delete x.PictureFileId
        x.Gender = x.Gender === 1 ? vm.$t('select-gender-male') : x.Gender === 2 ? vm.$t('select-gender-female') : vm.$t('select-gender-other')
      })
      vm.entrepreneurStats = entrepreneurStats

      userStats.Users.forEach(x => {
        if (x.HeardAbout !== null) {
          x.HeardAbout = vm.$t(vm.getHeardAbout(x.HeardAbout))
        }
        x.Type = x.Type === 1 ? 'Administrateur' : 'Utilisateur'
      })
      vm.userStats = userStats

      var proposedPlace = ['proposed-place-choose', 'proposed-place-1-label', 'proposed-place-2-label', 'proposed-place-3-label']

      gatheringStats.Gatherings.forEach(x => {
        delete x.PhotoFileId
        delete x.PhotoUri
        delete x.BusinessIds

        if (x.Region !== null && x.Region !== '') {
          x.Region = vm.$t(REGION_LABELS[x.Region])
        } else {
          x.Region = vm.$t('region-choose')
        }

        if (x.ProposedPlace !== null && x.ProposedPlace !== '') {
          x.ProposedPlace = vm.$t(proposedPlace[x.ProposedPlace])
        } else {
          x.ProposedPlace = vm.$t(proposedPlace[0])
        }
      })
      vm.gatheringStats = gatheringStats

      LoaderService.hideLoader()
    })
  }
}
</script>
<style scoped>
.report-button {
  margin-bottom: 15px;
}
</style>
